import Title from "components/Title";
import Spacer from "components/Spacer";
import Container from "components/Container";
import { Breadcrumb, Table } from "antd";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useUrlSearchParams } from "use-url-search-params";
import { useList } from "modules/serviceRegister/hooks";
import Pagination from "containers/Pagination";
import FilterList from "./components/FilterList";
import Button from "components/Button";
import * as Icons from "assets/icons";
import { useNavigate } from "react-router";
import QuickViewModal from "./components/QuickViewModal";

const mockData = [
    {
        "id": "2",
        "number": "0021",
        "serviceName": "Oʻzbekiston Respublikasi Prezidenti va Hukumati qarorlariga binoan olib chiqiladigan buyumlar va mahsulotlarni eksport qilishga doir ruxsatnoma",
        "organization": "Oʻzbekiston Respublikasi Vazirlar Mahkamasi",
        "subjectType": "Yuridik shaxs",
        "serviceForm": "Elektron",
        "paymentType": "Bepul",
        "serviceResult": "Ruxsatnoma"
    },
    {
        "id": "3",
        "number": "0022",
        "serviceName": "Fuqaro aviatsiyasi havo kemalarida portlovchi materiallarni tashish uchun ruxsatnoma",
        "organization": "Oʻzbekiston Respublikasi Vazirlar Mahkamasi",
        "subjectType": "Jismoniy va yuridik shaxslar",
        "serviceForm": "Anʼanaviy",
        "paymentType": "Pullik",
        "serviceResult": "Qaror"
    },
    {
        "id": "4",
        "number": "0023",
        "serviceName": "Sanitariya-muhofaza zonasida joylashgan obyektlar va inshootlarning profili oʻzgargan taqdirda ulardan xoʻjalik maqsadida foydalanish uchun ruxsatnoma",
        "organization": "Oʻzbekiston Respublikasi Vazirlar Mahkamasi",
        "subjectType": "Jismoniy va yuridik shaxslar",
        "serviceForm": "Elektron",
        "paymentType": "Pullik",
        "serviceResult": "Ruxsatnoma"
    },
    {
        "id": "5",
        "number": "0024",
        "serviceName": "Maxsus turdagi tovarlar eksporti va importi uchun litsenziya",
        "organization": "Oʻzbekiston Respublikasi Vazirlar Mahkamasi",
        "subjectType": "Jismoniy va yuridik shaxslar",
        "serviceForm": "Elektron",
        "paymentType": "Bepul",
        "serviceResult": "Litsenziya"
    },
    {
        "id": "6",
        "number": "0025",
        "serviceName": "Yuklarning muruvvat yordamiga mansubligini tasdiqlash",
        "organization": "Oʻzbekiston Respublikasi Vazirlar Mahkamasi",
        "subjectType": "Jismoniy va yuridik shaxslar",
        "serviceForm": "Anʼanaviy",
        "paymentType": "Bepul",
        "serviceResult": "Xulosa"
    },
    {
        "id": "7",
        "number": "0026",
        "serviceName": "Texnik va maxsus maqsadlardagi pirotexnika vositalarining (xavflilikning III — V darajalari) Oʻzbekiston Respublikasiga olib kirilishiga va ulardan foydalanilishiga doir ruxsatnoma, bundan sanoat maqsadlarida foydalaniladigan pirotexnika vositalari mustasno",
        "organization": "Oʻzbekiston Respublikasi Vazirlar Mahkamasi",
        "subjectType": "Yuridik shaxs",
        "serviceForm": "Elektron",
        "paymentType": "Pullik",
        "serviceResult": "Ruxsatnoma"
    },
    {
        "id": "8",
        "number": "0027",
        "serviceName": "Yirik investitsiya loyihasini amalga oshirish uchun eng yaxshi taklifni tanlab olish",
        "organization": "Oʻzbekiston Respublikasi Vazirlar Mahkamasi Tashqi savdo, investitsiyalar, mahalliy sanoatni rivojlantirish va texnik jihatdan tartibga solish masalalari boʻyicha Hukumat komissiyasi",
        "subjectType": "Jismoniy va yuridik shaxslar",
        "serviceForm": "Elektron",
        "paymentType": "Pullik",
        "serviceResult": "Yer ijara shartnomasi"
    },
    {
        "id": "9",
        "number": "0028",
        "serviceName": "Oʻzbekiston Respublikasi hududida xorijiy ommaviy axborot vositalarining teleradio mahsulotlarini tarqatish huquqini berish uchun ruxsatnoma",
        "organization": "Oʻzbekiston Respublikasi Vazirlar Mahkamasi (Axborot faoliyati va maʼlumotlar uzatishni takomillashtirish va samaradorligini oshirish boʻyicha idoralararo muvofiqlashtirish komissiyasi)",
        "subjectType": "Yuridik shaxs",
        "serviceForm": "Anʼanaviy",
        "paymentType": "Pullik",
        "serviceResult": "Ruxsatnoma"
  },
    {
        "id": "10",
        "number": "0041",
        "serviceName": "Fuqarolarni tibbiy-ijtimoiy ekspert komissiyalarida koʻrikdan oʻtkazish",
        "organization": "Tibbiy-ijtimoiy ekspert komissiyalari",
        "subjectType": "Jismoniy shaxs",
        "serviceForm": "Anʼanaviy",
        "paymentType": "Bepul",
        "serviceResult": "Maʼlumotnoma"
  },
    {
        "id": "11",
        "number": "0042",
        "serviceName": "Shaxs nogironligi boʻlgan shaxs (bola) deb eʼtirof etilmaganligi toʻgʻrisidagi maʼlumotnoma berish",
        "organization": "Tibbiy-ijtimoiy ekspert komissiyalari",
        "subjectType": "Jismoniy shaxs",
        "serviceForm": "Anʼanaviy",
        "paymentType": "Bepul",
        "serviceResult": "Maʼlumotnoma"
    }
]

const ServiceRegister = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [params, setParams] = useUrlSearchParams();
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState(0);

  const { items, meta, isFetched } = useList({
    params: {
      search,
      page,
      filter: [
        // {
        //   key: "created_by_organization.id",
        //   operation: "=",
        //   value: params.organization_id,
        //   type: "STRING",
        // },
        // {
        //   key: "open",
        //   operation: "=",
        //   value: true,
        //   type: "BOOL",
        // },
        // {
        //   key: "function_name.sphere.id",
        //   operation: "=",
        //   value: params.sphere_id,
        //   type: "NUMBER",
        // },
        // {
        //   key: "function_name.code",
        //   operation: "%_%",
        //   value: params.function_code,
        //   type: "STRING",
        // },
        // {
        //   key: `function_name.name.${i18n.language}`,
        //   operation: "%_%",
        //   value: params.function_name,
        //   type: "JSON",
        // },
        // {
        //   key: "personal",
        //   operation: "=",
        //   value:
        //     params.personal === "transferred"
        //       ? "true"
        //       : params.personal === "not_transferred"
        //       ? "false"
        //       : "",
        //   type: "BOOL",
        // },
      ],
    },
  });

  return (
    <>
      <Container>
        <Spacer size={35} />

        <Breadcrumb separator=">">
          <Breadcrumb.Item href="/">{t("home")}</Breadcrumb.Item>
          <Breadcrumb.Item>{t("service_register")}</Breadcrumb.Item>
        </Breadcrumb>

        <Spacer size={32} />

        <Title align="left" text={t("service_register")} />
        <Spacer size={40} />

        <FilterList {...{ params, setParams, setSearch }} />

        <Spacer size={20} />
        <Table
          rowKey="id"
          defaultSort="-createdAt"
          columns={[
            {
              title: "№",
              render: (text, record, index) =>
                (meta.current - 1) * meta.perPage + index + 1,
            },
            {
              key: "unique_number",
              title: t("column_unique_number"),
              dataIndex: ["number"],
            },
            {
              key: "service_name",
              title: t("column_service_name"),
              dataIndex: ["serviceName"],
            },
            {
              key: "users_type",
              title: t("column_users_type"),
              dataIndex: ["subjectType"],
            },
            {
              key: "service_form",
              title: t("column_service_form"),
              dataIndex: ["serviceForm"],
            },

            {
              key: "with_payment",
              title: t("column_with_payment"),
              dataIndex: ["paymentType"],
            },
            {
              key: "service_response",
              title: t("column_service_response"),
              dataIndex: ["serviceResult"],
            },
            {
              key: "actions",
              render: (_, record) => (
                <Button
                  background="secondary"
                  color="secondary"
                  border="none"
                  radius="xs"
                  iconOnly
                  onClick={navigate.bind(null, `#${record.id}`)}>
                  <Icons.ArrowRight />
                </Button>
              ),
            },
          ]}
          dataSource={mockData}
          pagination={false}
          loading={!isFetched}
          onRow={record => {
            return {
              onClick: event => {
                if (event.target.localName === "td")
                  navigate(`/service-register/view/${record.id}`);
              },
            };
          }}
          scroll={{ x: 1400 }}
        />

        <Spacer size={32} />

        <Pagination
          current={meta.current}
          total={meta.totalPages}
          currentItems={items.length}
          totalItems={meta.totalItems}
          onChange={page => setPage(page)}
        />

        <Spacer size={140} />
      </Container>
      <QuickViewModal />
    </>
  );
};

export default ServiceRegister;
